module.exports = __webpack_public_path__ + "img/logo-loto-plus-hotpicks.9a0df106.jpg";